import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './LandingLegalPage.css';
import messages from '../../locale/messages';
import { legalRichTextValues } from './legalMessageValues';
import LandingLegalPage from './LandingLegalPage';

class LandingTerms extends React.Component {
  render() {
    return (
      <LandingLegalPage
        activePage="terms"
        pageTitleMessage={messages.newLandingLegalTermsPageTitle}
      >
        <section className={s.legalSection}>
          <h2><FormattedMessage {...messages.newLandingLegalTermsServiceHeading} /></h2>

          <h3><FormattedMessage {...messages.newLandingLegalTermsAcceptHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTermsAcceptText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsAccountsHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTermsAccountsText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsEligibilityHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTermsEligibilityText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsResponsibilitiesHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTermsResponsibilitiesText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsRentalHeading} /></h3>
          <p>
            <FormattedMessage
              {...messages.newLandingLegalTermsRental51}
              values={legalRichTextValues}
            />
          </p>
          <p>
            <FormattedMessage
              {...messages.newLandingLegalTermsRental52}
              values={legalRichTextValues}
            />
          </p>
          <p>
            <FormattedMessage
              {...messages.newLandingLegalTermsRental53}
              values={legalRichTextValues}
            />
          </p>
          <p>
            <FormattedMessage
              {...messages.newLandingLegalTermsRental54}
              values={legalRichTextValues}
            />
          </p>
          <p>
            <FormattedMessage
              {...messages.newLandingLegalTermsRental55}
              values={legalRichTextValues}
            />
          </p>
          <p>
            <FormattedMessage
              {...messages.newLandingLegalTermsRental56}
              values={legalRichTextValues}
            />
          </p>
          <p>
            <FormattedMessage
              {...messages.newLandingLegalTermsRental57Intro}
              values={legalRichTextValues}
            />
          </p>
          <ul>
            <li><FormattedMessage {...messages.newLandingLegalTermsRental57Item1} /></li>
            <li><FormattedMessage {...messages.newLandingLegalTermsRental57Item2} /></li>
            <li><FormattedMessage {...messages.newLandingLegalTermsRental57Item3} /></li>
            <li><FormattedMessage {...messages.newLandingLegalTermsRental57Item4} /></li>
          </ul>
          <p><FormattedMessage {...messages.newLandingLegalTermsRental57Outro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsPaymentsHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTermsPaymentsText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsProhibitedHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTermsProhibitedText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsTerminationHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTermsTerminationText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTermsChangesHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTermsChangesText} /></p>
        </section>

        <section className={s.legalSection}>
          <hr className={s.sectionDivider} />
          <h2><FormattedMessage {...messages.newLandingLegalPrivacyHeading} /></h2>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyIntro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyCollectionHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyCollectionText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyUseHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyUseIntro} /></p>
          <ul>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyUseItem1} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyUseItem2} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyUseItem3} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyUseItem4} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyUseItem5} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyUseItem6} /></li>
          </ul>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyUseOutro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacySharingHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacySharingIntro} /></p>
          <ul>
            <li><FormattedMessage {...messages.newLandingLegalPrivacySharingItem1} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacySharingItem2} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacySharingItem3} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacySharingItem4} /></li>
          </ul>
          <p><FormattedMessage {...messages.newLandingLegalPrivacySharingOutro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacySecurityHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacySecurityText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyCookiesHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyCookiesText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyRightsHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyRightsIntro} /></p>
          <ul>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyRightsItem1} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyRightsItem2} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyRightsItem3} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyRightsItem4} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyRightsItem5} /></li>
            <li><FormattedMessage {...messages.newLandingLegalPrivacyRightsItem6} /></li>
          </ul>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyRightsOutro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyChildrenHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyChildrenText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyChangesHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyChangesText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalPrivacyContactHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyContactText1} /></p>
          <p><FormattedMessage {...messages.newLandingLegalPrivacyContactText2} /></p>
        </section>
      </LandingLegalPage>
    );
  }
}

export default withStyles(s)(LandingTerms);
